import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  back() {
    // console.log("[X] click", { timestamp: new Date().toISOString() })

    // Crear overlay negro inmediatamente para asegurar visibilidad durante navegación
    this.createInstantOverlay()

    // Verificar si el controller EXIT está conectado antes de disparar el evento
    const exitController = document.body.getAttribute('data-controller')
    // console.log("[X] data-controller en body", { value: exitController, timestamp: new Date().toISOString() })

    // Activar transición de salida antes de navegar usando CustomEvent nativo
    // console.log("[X] dispatch transition-out (CustomEvent)", { timestamp: new Date().toISOString() })
    const event = new CustomEvent('transition-out', { bubbles: true })
    document.body.dispatchEvent(event)

    // Esperar a que la transición de salida se complete antes de navegar
    // console.log("[X] history.back programado (500ms delay)", { timestamp: new Date().toISOString() })
    setTimeout(() => {
      const referrer = document.referrer
      const sameOrigin = referrer && new URL(referrer).origin === window.location.origin

      if (window.history.length > 1 && sameOrigin) {
        window.history.back()
      } else {
        window.location.href = "/"
      }
    }, 500)
  }

  createInstantOverlay() {
    // console.log("[X] createInstantOverlay", { timestamp: new Date().toISOString() })
    // Buscar el elemento header para calcular su altura
    const headerElement = document.querySelector('header')
    const headerHeight = headerElement ? headerElement.offsetHeight : 0

    // Crear overlay negro instantáneo
    const overlay = document.createElement("div")
    overlay.className = "close-article-instant-overlay"
    overlay.style.cssText = `
      position: fixed;
      top: ${headerHeight}px;
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(100vh - ${headerHeight}px);
      background: black;
      z-index: 50;
      pointer-events: none;
    `
    document.body.appendChild(overlay)
    // console.log("[X] overlay instantáneo creado", { timestamp: new Date().toISOString() })

    // Guardar referencia para eliminarlo después
    this.overlayElement = overlay
  }
}
